import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { money } from './crmConstants';

export const calcTotals = ({ items = [], discount_pct = 0, vat_pct = 0 }) => {
  const subtotal = items.reduce((s, i) => s + Number(i.qty || 0) * Number(i.unit_price || 0), 0);
  const discount = subtotal * Number(discount_pct || 0) / 100;
  const taxable = subtotal - discount;
  const vat = taxable * Number(vat_pct || 0) / 100;
  return { subtotal, discount, taxable, vat, total: taxable + vat };
};

const Num = ({ value, onChange, testId, className = 'w-20' }) => (
  <input type="number" step="any" value={value} onChange={(e) => onChange(e.target.value === '' ? 0 : Number(e.target.value))}
    className={`${className} px-2 py-1.5 bg-slate-900 border border-slate-700 rounded text-white text-sm text-right`} data-testid={testId} />
);

export const OfferItemsEditor = ({ value, onChange, testIdPrefix = 'items' }) => {
  const items = value.items || [];
  const setItem = (i, patch) => onChange({ ...value, items: items.map((it, j) => (j === i ? { ...it, ...patch } : it)) });
  const t = calcTotals(value);
  return (
    <div className="space-y-2">
      <div className="space-y-1.5">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-2">
            <input value={it.description} onChange={(e) => setItem(i, { description: e.target.value })} placeholder="Descrizione"
              className="flex-1 px-2 py-1.5 bg-slate-900 border border-slate-700 rounded text-white text-sm" data-testid={`${testIdPrefix}-desc-${i}`} />
            <Num value={it.qty} onChange={(v) => setItem(i, { qty: v })} testId={`${testIdPrefix}-qty-${i}`} className="w-16" />
            <span className="text-slate-500 text-xs">×</span>
            <Num value={it.unit_price} onChange={(v) => setItem(i, { unit_price: v })} testId={`${testIdPrefix}-price-${i}`} className="w-24" />
            <span className="w-24 text-right text-xs text-slate-300">{money(it.qty * it.unit_price)}</span>
            <button type="button" onClick={() => onChange({ ...value, items: items.filter((_, j) => j !== i) })} className="text-slate-500 hover:text-rose-400" data-testid={`${testIdPrefix}-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <button type="button" onClick={() => onChange({ ...value, items: [...items, { description: '', qty: 1, unit_price: 0 }] })} className="text-xs text-amber-400 hover:text-amber-300 flex items-center gap-1" data-testid={`${testIdPrefix}-add`}>
        <Plus className="w-3.5 h-3.5" /> Aggiungi riga
      </button>
      <div className="flex flex-wrap items-center justify-end gap-4 pt-2 border-t border-slate-700 text-sm">
        <label className="flex items-center gap-2 text-slate-300">Sconto % <Num value={value.discount_pct || 0} onChange={(v) => onChange({ ...value, discount_pct: v })} testId={`${testIdPrefix}-discount`} className="w-16" /></label>
        <label className="flex items-center gap-2 text-slate-300">IVA % <Num value={value.vat_pct || 0} onChange={(v) => onChange({ ...value, vat_pct: v })} testId={`${testIdPrefix}-vat`} className="w-16" /></label>
      </div>
      <div className="text-right text-sm space-y-0.5">
        <p className="text-slate-400">Imponibile {money(t.taxable)}{t.discount > 0 ? ` (sconto ${money(t.discount)})` : ''} · IVA {money(t.vat)}</p>
        <p className="text-white font-bold text-base" data-testid={`${testIdPrefix}-total`}>Totale {money(t.total)}</p>
      </div>
    </div>
  );
};
